export function formatDate(isoDateString, t, language = 'nl') {
    const date = new Date(isoDateString);
    const day = date.getUTCDate().toString();
    const month = (date.getUTCMonth() + 1).toString().padStart(2, '0');
    const translatedMonth = t(`months.${month}`);
    const transformedMonth = language === 'nl' || language == 'fr' ? translatedMonth.toLowerCase() : translatedMonth;
    const year = date.getUTCFullYear();
    return `${day}${language === 'de' ? '. ' : ' '}${transformedMonth} ${year}`;
}
//# sourceMappingURL=formatDate.js.map